/**
 * Archivo Js que permite definir, administrar, controlar y configurar las rutas del modulo 
 * Administrar, se integra facilmente con el router principal del Vue, facilita
 * la creacion y el mantenimiento de las peticiones en el proyecto
 */
import store from '../../store/';

/**
 * Definicion de lista de rutas aplicadas al modulo Aministrar
 */
const administrarRouter = [
	{
		/**Definicion de la ruta del modulo Administrar */
		path: '/administrar',

		/**Definicion del nombre de la ruta Administrar */
		name: 'administrar',

		/**Definicion de la vista Administrar */
		//component: () => import('@/views/administrator/Administrar.vue'),

		component: resolve => {
			require.ensure(['@/views/administrator/Administrar.vue'], () => {
				resolve(require('@/views/administrator/Administrar.vue'))
			})
		},

		/**Definicion de metadatos */
		meta: {
			requiresAuth: true
		},

		/**
		 * Metodo que permite redireccionar la vista de los 
		 * submodulos de acuerdo a los permisos del usuario que inicia sesion 
		 * */
		redirect: () => {
			let permission = store.state.Session.permission;
			if (permission.find((authority) => new RegExp('1.3', 'g').test(authority))) {
				return {
					name: 'usuario'
				};
			} else if (permission.find((authority) => new RegExp('1.4', 'g').test(authority))) {
				return {
					name: 'dependencia'
				};
			} else if (permission.find((authority) => new RegExp('1.2', 'g').test(authority))) {
				return {
					name: 'rolSistema'
				};
			}	
		},

		/**Lista de rutas de los submodulos asociados al modulo administrar */
		children: [
			{
				path: 'usuario',
				name: 'usuario',
				component: resolve => {
					require.ensure(['@/views/administrator/Usuario.vue'], () => {
						resolve(require('@/views/administrator/Usuario.vue'))
					})
				},
				meta: {
					requiresAuth: true,
				}
			},
			{
				path: 'dependencia',
				name: 'dependencia',
				component: resolve => {
					require.ensure(['@/views/administrator/Dependencia.vue'], () => {
						resolve(require('@/views/administrator/Dependencia.vue'))
					})
				},
				meta: {
					requiresAuth: true
				}
			},
			{
				path: 'rolsistema',
				name: 'rolSistema',
				component: resolve => {
					require.ensure(['@/views/administrator/RolSistema.vue'], () => {
						resolve(require('@/views/administrator/RolSistema.vue'))
					})
				},
				meta: {
					requiresAuth: true
				}
			},
		]
	}
]

/**Exportamos las rutas del modulo Administrar */
export default administrarRouter;




